module.exports = __webpack_public_path__ + "static/img/HList8.8ac8e02c.png";